import { render, staticRenderFns } from "./TextEllipsisExample.vue?vue&type=template&id=7b3f3e8b&scoped=true&"
import script from "./TextEllipsisExample.vue?vue&type=script&lang=js&"
export * from "./TextEllipsisExample.vue?vue&type=script&lang=js&"
import style0 from "./TextEllipsisExample.vue?vue&type=style&index=0&id=7b3f3e8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3f3e8b",
  null
  
)

export default component.exports